import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';

export interface ApiKey {
  id: string;
  name: string;
  role: 'owner' | 'manager';
  prefix: string;
  scope: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
  /** Present on the owner list view. */
  createdByEmail?: string;
  createdByName?: string;
}

/** Create response additionally carries the plaintext token — shown once. */
export interface CreatedApiKey extends ApiKey {
  token: string;
}

export function useApiKeys() {
  return useQuery({
    queryKey: ['api-keys'],
    queryFn: () => apiFetch<{ apiKeys: ApiKey[] }>('/api/v1/admin/api-keys').then((r) => r.apiKeys),
  });
}

export function useCreateApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string }) =>
      apiFetch<{ apiKey: CreatedApiKey }>('/api/v1/admin/api-keys', {
        method: 'POST',
        body: JSON.stringify(body),
      }).then((r) => r.apiKey),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
}

export function useRevokeApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<{ apiKey: ApiKey }>(`/api/v1/admin/api-keys/${id}/revoke`, {
        method: 'POST',
      }).then((r) => r.apiKey),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
}
